<template>
  <div class="MenuPanel">
    <div class="Menu__panel"
      v-if="selectedFilterOptions.length && hasNextItem"
        :style="[
          positionStyle,
          (isTranslating) ? { transition: `left ${menuSwitchSpeed}s` } : {}
        ]">
      <div v-if="list.title" class="Menu__header">
        {{ list.title }}
      </div>

      <ul class="Menu__list" :class="list.parent === null && list.children.length === 1 ? 'btn-block btn-collections' : ''">
        <li class="Menu__item" v-if="list.parent && list.parent.code === 'pris_collections'" @click="toggleCollectionShowAll({ clickedFilter: list.filter, filterParent: list.parent })">
          <div class="text">Show All</div>
          <span class="check" v-if="selectedFilterOptionCodes.includes(list.filter.code)">
            <i class="fa fa-check" aria-hidden="true"></i>
          </span>
        </li>
        <li v-for="item in list.children" @click="handleItemClicked(item)" class="Menu__item" :class="list.parent === null && list.children.length === 1 ? 'text-align' : ''"  :key="item.index">
          <template v-if="item.children.length > 0">
            <div class="text">{{ item.filter.code === 'pris_collections' ? 'View Collections' : item.title }}</div>
            <span class="check-parent" v-if="areAnyChildrenSelected(item)">
              <i class="fa fa-check" aria-hidden="true"></i>
            </span>
            <span class="arrow" v-if="item.filter.code !== 'pris_collections'">
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </span>
          </template>

          <div v-else>
            <div class="text">{{ item.title }}</div>
            <span class="check" v-if="selectedFilterOptionCodes.includes(item.filter.code)">
              <i class="fa fa-check" aria-hidden="true"></i>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    list: {
      type: Object,
      required: true,
    },
    positionStyle: {
      type: Object,
      required: true,
    },
    showHeaderArrow: {
      type: Boolean,
      default: false,
    },
    isTranslating: {
      type: Boolean,
      default: false,
    },
    menuSwitchSpeed: {
      type: Number,
      required: true
    },

    handleHeaderClicked: {
      type: Function,
      default: () => {}
    },
    handleItemClicked: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedFilterOptions'
    ]),
    selectedFilterOptionCodes() {
      return this.selectedFilterOptions.map(option => option.code);
    },
    hasNextItem() {
      if(this.selectedFilterOptions?.length) {
        return this.selectedFilterOptions[0].sub_categories.length > 0;
      }
    }
  },
  methods: {
    ...mapActions([
      'toggleCollectionShowAll'
    ]),
    areAnyChildrenSelected(item) {
      if (!item) return false;

      const itemIsSelected = this.selectedFilterOptionCodes.includes(item.filter.code);
      if (itemIsSelected) return true;

      const itemHasChildren = item.children.length > 0;
      if (itemHasChildren) {
        return item.children.some(child => this.areAnyChildrenSelected(child));
      }

      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
  .text-align {
    justify-content: center;
    padding: 0;
  }

  .btn-collections {
    border-radius: 4px;
    background-color:#ddd;
    border: none;
    transition: all 0.5s;
  }


  .btn-collections .text {
    cursor: pointer;
    display: inline-block;
    position: relative;
    transition: 0.5s;
  }

  .btn-collections .text:after {
    content: '»';
    position: absolute;
    opacity: 0;
    top: 0;
    right: -20px;
    transition: 0.5s;
  }

  .btn-collections:hover .text {
    padding-right: 25px;
  }

  .btn-collections:hover .text:after {
    opacity: 1;
    right: 0;
  }


  ul, li {
    padding: 0;
    margin: 0;
  }

  .Menu__panel {
    position: absolute;
    top: 0;
    height: auto;
    width: 100%;
    background-color: #fff;
    border-radius: 6px;
  }

  .Menu__header {
    display: flex;
    align-items: center;
    height: 50px;
    font-size: 16px;
    font-weight: 700;
    border-bottom: 1px solid #ddd;

    .arrow {
      padding-top: 2px;
      fill: #fff;
      margin-right: 10px;
      width: 10px;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .Menu__list {
    list-style: none;
    padding-bottom: 2px;

    .separator {
      border-bottom: 1px solid #d5dbdb;
      padding: 2px 0 0 0;
      margin: 0;
    }
  }

  .Menu__item {
    color: #4a4a4a;
    height: 45px;
    display: flex;
    font-size: 16px;
    align-items: center;
    cursor: pointer;
    position: relative;

    a {
      color: #4a4a4a;
      text-decoration: none;
    }

    &.active {
      color: rgb(249,152,57);
    }

    .arrow {
      padding-top: 2px;
      display: flex;
      align-items: center;
      width: 10px;
      height: 100%;
      position: absolute;
      right: 20px;
    }

    .check {
      display: flex;
      align-items: center;
      width: 10px;
      height: 100%;
      position: absolute;
      right: 20px;
      top: 0;
      color: orange;
    }

    .check-parent {
      @extend .check;
      right: 45px;
    }

    .selection-count {
      display: flex;
      align-items: center;
      width: 19px;
      height: 19px;
      color: white;
      background: rgb(249,152,57);
      border-radius: 9px;
      padding-left: 5px;
      font-weight: bold;
      position: absolute;
      right: 40px;
      top: 12px;
    }
  }
</style>
